import { DEFAULTS } from './defaults.js';
import { getTextButtons } from './getTextButtons.js';
import { lineSpacing } from './tiptap.js';
import { LINE_SPACING_TYPE } from './types.js';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import './icons/toolbars-v3/LineSpacingIcon.js';
import 'react';
import './LineSpacingPanelComponent.js';
import 'wix-rich-content-plugin-commons';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginLineSpacing = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINE_SPACING_TYPE,
    textButtons: getTextButtons(),
    tiptapExtensions: [lineSpacing]
  };
};

export { pluginLineSpacing };
//# sourceMappingURL=editor.js.map
